"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _core = require("@material-ui/core");
var _appContext = _interopRequireDefault(require("../../context/appContext"));
var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));
var _confirmInvitationToken = _interopRequireDefault(require("../../utils/confirmInvitationToken"));
var _sendAccountInvitation = _interopRequireDefault(require("../../utils/sendAccountInvitation"));
var _input = _interopRequireDefault(require("../form/input"));
var _select = _interopRequireDefault(require("../form/select"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  form: {
    margin: theme.spacing(6, 0)
  }
}));
const UserInvitePerson = () => {
  var _customLinks$find;
  const [appData] = (0, _react.useContext)(_appContext.default);
  const {
    customLinks = []
  } = appData || {};
  const [formMessage, setFormMessage] = (0, _react.useState)();
  const [loading, setLoading] = (0, _react.useState)(false);
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const history = (0, _reactRouterDom.useHistory)();
  const location = (0, _reactRouterDom.useLocation)();
  const searchParams = new URLSearchParams(location.search);
  const css = useStyles();
  const token = searchParams.get("token");
  const successURL = customLinks === null || customLinks === void 0 || (_customLinks$find = customLinks.find(_ref => {
    let {
      identifier
    } = _ref;
    return identifier === "user-invite-person-success";
  })) === null || _customLinks$find === void 0 ? void 0 : _customLinks$find.url;
  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.target;
    setLoading(true);
    const {
      msg,
      success
    } = token ? await (0, _confirmInvitationToken.default)(form) : await (0, _sendAccountInvitation.default)(form);
    setLoading(false);
    if (success) {
      if (successURL) {
        history.push(successURL);
        return;
      }
      setFormMessage({
        type: "success",
        text: t("site.userInvitePerson.messages.success")
      });
      return;
    }
    const errorMessage = msg === "already_exists" ? t("site.userInvitePerson.messages.error.alreadyExists") : t("site.userInvitePerson.messages.error.default");
    setFormMessage({
      type: "error",
      text: errorMessage
    });
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    className: css.form,
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement("input", {
    name: "lang",
    type: "hidden",
    value: i18n.language
  }), token && /*#__PURE__*/_react.default.createElement("input", {
    name: "invitationToken",
    type: "hidden",
    value: token
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_select.default, {
    label: i18n.language === "de" ? "Anrede" : "Salutation",
    name: "gender",
    required: true,
    options: [{
      "attr-value": "m",
      text: i18n.language === "de" ? "Herr" : "Mr."
    }, {
      "attr-value": "w",
      text: i18n.language === "de" ? "Frau" : "Mrs."
    }, {
      "attr-value": "d",
      text: i18n.language === "de" ? "Divers" : "Diverse"
    }]
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "firstName",
    label: i18n.language === "de" ? "Vorname" : "Firstname",
    required: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "lastName",
    label: i18n.language === "de" ? "Nachname" : "Lastname",
    required: true
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "email",
    label: i18n.language === "de" ? "E-Mail Adresse" : "E-mail address",
    required: true
  })), formMessage && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: formMessage === null || formMessage === void 0 ? void 0 : formMessage.type
  }, formMessage === null || formMessage === void 0 ? void 0 : formMessage.text)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: loading,
    type: "submit",
    variant: "contained",
    color: "primary"
  }, t("site.userInvitePerson.button"))))));
};
var _default = exports.default = UserInvitePerson;